module.exports = "https://cdn.redage.net/src/views/player/help/images/azart2.jpg";